<template>
    <footer>
    </footer>
</template>

<script>
    export default {
        name: 'footer',
        data () {
            return {

            }
        }
    }
</script>

<style lang="scss">
    // @import '../../scss/footer.scss';
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue